export default () => {
    document.addEventListener('click', (e) => {
        if (e.target.classList && e.target.classList.contains('copylink')) {
            e.preventDefault();
            let href = e.target.getAttribute('href');
            navigator.clipboard.writeText(href);
            document.getElementsByClassName('copied')[0].classList.remove('hidden');
            setTimeout(() => {
                document.getElementsByClassName('copied')[0].classList.add('hidden');
            }, 5000);
        }
    });
}
